export default {
  UPDATE_COMPANYINFO (context, companyInfo) {
    context.commit('UPDATE_COMPANYINFO', companyInfo);
  },
};
